import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { MaquinasEquipItensForm, MaquinasEquipItensSchema } from "../../../schemas/MaquinasEquipItens_cadastro/MaquinasEquipItens_cadastro";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";

import DefaultFormInput from "../../../../../../common/components/default_form_input";

/**
 * ModalMaquinasEquipItens
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  selectedMaquinaEquipItem: any;
  onClose: () => void;
  onSubmit: (form: MaquinasEquipItensForm) => void;
};

export const ModalMaquinasEquipItens = ({
  open,
  saving,
  loading,
  selectedMaquinaEquipItem,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<MaquinasEquipItensForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(MaquinasEquipItensSchema),
  });

  useEffect(() => {
    if (selectedMaquinaEquipItem) {
      hookForm.setValue("ordem", selectedMaquinaEquipItem.ordem ?? "");
      hookForm.setValue("descricao", selectedMaquinaEquipItem.descricao ?? "");
    } else {
      hookForm.reset({ ordem: "", descricao: "" });
    }
  }, [
    hookForm,
    selectedMaquinaEquipItem,
    open,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Maquina Equipamento Item"
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col gap-2 my-2">
        <DefaultFormInput
          name="ordem"
          label="Ordem"
          required={false}
          reactHookForm={hookForm}
        />

        <DefaultFormInput
          name="descricao"
          label="Descrição"
          reactHookForm={hookForm}
          required={false}
        />
      </div>
    </BaseFormControlledModal>
  );
};
